module.exports = __webpack_public_path__ + "i18n/es.42e992ccf25daf8d36163707c39100d5.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/es.json
// module id = 1284
// module chunks = 60